import { Action } from '@ngrx/store';
import { ActionTypes } from '../../core/models/actionTypes';
import { Timezone } from '../models/timezone';

export const TimezonesAction = (timezones: Timezone[]) => {
  return <Action>{ type: ActionTypes.Timezones, payload: timezones };
};
